export default ({ preset, blur, hdr = true, rotation }) => {
  const externalFile = getExternalFile(preset, hdr);

  return {
    file: externalFile,
    preset: (hdr && externalFile) ? undefined : preset,
    blur,
    y: rotation,
    userEnvironment: isUserEnvironment(preset),
  };
};

const getExternalFile = (preset, hdr) => {
  if (isUserEnvironment(preset)) {
    return preset;
  }
  if (hdr) {
    return getHDRFile(preset);
  }
  return getLDRFile(preset);
};

const isUserEnvironment = (preset) => preset.startsWith('http');

const getLDRFile = (presetName) => {
  const basePath = 'https://dimensions-art.cloudinary.net/prod-assets/image/upload/q_auto/';
  const LDRS = {
    hdr_23: "v1707896717/renderer-assets/ldr/HDR_23.jpg",
    bright_reflection: "v1715344863/renderer-assets/ldr/bright-ref-4.jpg",
    studio_warm: "v1720706002/renderer-assets/ldr/Studio-Warm_p6ar2d.jpg",
    studio_2_sides_warm: "v1698831477/renderer-assets/ldr/studio_small_09.jpg",
    studio_hard_light: "v1698915500/renderer-assets/ldr/cyclorama_hard_light.jpg",
    neutral: "v1698830646/renderer-assets/ldr/neutral.jpg",
    outdoor_cloudy: "v1720706002/renderer-assets/ldr/Outdoor-Cloudy_orugy5.jpg",
    outdoor_evening: "v1720706002/renderer-assets/ldr/Outdoor-Evening_weovrp.jpg",
    outdoor_sunny: "v1720706023/renderer-assets/ldr/Outdoor-Sunny_bvcpmu.jpg",
    indoor_cool: "v1720706002/renderer-assets/ldr/Indoor-Cool_foalr2.jpg",
    indoor_neutral: "v1720706002/renderer-assets/ldr/Indoor-Neutral-_ehutkq.jpg",
    indoor_warm: "v1720706003/renderer-assets/ldr/Indoor-Warm_fdgeyp.jpg",
    kitchen: "renderer-assets/ldr/kitchen",
    livingroom: "renderer-assets/ldr/livingroom",
    office: "renderer-assets/ldr/office",
    patio: "renderer-assets/ldr/patio",
    bedroom: "renderer-assets/ldr/bedroom",
    //deprecated
    studio_bright: "v1698830650/renderer-assets/ldr/jewelry_HDRI_1.jpg",
    metal_reflection: "v1716211804/renderer-assets/ldr/metal-ref.jpg",
    studio_2_sides: "v1698831413/renderer-assets/ldr/studio_small_02.jpg",
    studio_front: "v1698831431/renderer-assets/ldr/studio_small_03.jpg",
    misty_sky: "v1698920349/renderer-assets/ldr/kloofendal_misty_morning_puresky.jpg",
    spruit_sunrise: "v1698830646/renderer-assets/ldr/spruit_sunrise_1k.jpg",
    whipple_creek: "v1698830645/renderer-assets/ldr/whipple_creek_regional_park_04_1k.jpg",
    music_hall: "v1698830649/renderer-assets/ldr/music_hall_01_1k.jpg",
    pillars: "v1698830645/renderer-assets/ldr/pillars_1k.jpg",
    aircraft_workshop: "v1698830647/renderer-assets/ldr/aircraft_workshop_01_1k.jpg"
  };

  return `${basePath}${LDRS[presetName]}`;
};

const getHDRFile = (presetName) => {
  const basePath = 'https://dimensions-art.cloudinary.net/prod-assets/raw/upload/';
  const HDRS = {
    hdr_23: "v1709562389/renderer-assets/hdr/HDR_23.hdr",
    bright_reflection: "v1715344892/renderer-assets/hdr/bright-ref-4.hdr",
    studio_warm: "v1720703970/renderer-assets/hdr/Studio_-_Warm_re4osl.hdr",
    studio_2_sides: "v1700128436/renderer-assets/hdr/studio_small_02_1k.hdr",
    studio_hard_light: "v1700128689/renderer-assets/hdr/cyclorama_hard_light_1k.hdr",
    neutral: "v1686564861/renderer-assets/hdr/neutral.hdr",
    outdoor_cloudy: "v1720704484/renderer-assets/hdr/Outdoor_-_Cloudy_xwe85v.hdr",
    outdoor_evening: "v1720704485/renderer-assets/hdr/Outdoor_-_Evening_dnvnog.hdr",
    outdoor_sunny: "v1720704485/renderer-assets/hdr/Outdoor_-_Sunny_wxrs1d.hdr",
    indoor_cool: "v1720704485/renderer-assets/hdr/Indoor_-_Cool_qhw9it.hdr",
    indoor_neutral: "v1720704485/renderer-assets/hdr/Indoor_-_Neutral_gszbwk.hdr",
    indoor_warm: "v1720704485/renderer-assets/hdr/Indoor_-_Warm_leg9lp.hdr",
    kitchen: "renderer-assets/hdr/kitchen.hdr",
    livingroom: "renderer-assets/hdr/livingroom.hdr",
    office: "renderer-assets/hdr/office.hdr",
    patio: "renderer-assets/hdr/patio.hdr",
    bedroom: "renderer-assets/hdr/bedroom.hdr",
    // deprecated
    studio_2_sides_warm: "v1700128612/renderer-assets/hdr/studio_small_09_1k.hdr",
    studio_front: "v1700128624/renderer-assets/hdr/studio_small_03_1k.hdr",
    metal_reflection: "v1715890653/renderer-assets/hdr/metal-ref.exr",
    studio_bright: "v1698664541/renderer-assets/hdr/jewelry_HDRI_1.hdr",
    misty_sky: "v1700128839/renderer-assets/hdr/kloofendal_misty_morning_puresky_1k.hdr",
    spruit_sunrise: "v1686564867/renderer-assets/hdr/spruit_sunrise_1k.hdr",
    whipple_creek: "v1686564871/renderer-assets/hdr/whipple_creek_regional_park_04_1k.hdr",
    music_hall: "v1686564866/renderer-assets/hdr/music_hall_01_1k.hdr",
    pillars: "v1686564869/renderer-assets/hdr/pillars_1k.hdr",
    aircraft_workshop: "v1686564868/renderer-assets/hdr/aircraft_workshop_01_1k.hdr"
  };

  return HDRS[presetName] ? `${basePath}${HDRS[presetName]}` : undefined;
};
